export default __webpack_public_path__ + "static/media/logo-close.e8dea49c.svg";